import React from "react";
import colors from "../Constant/colors";

const CreateExam = () => {
  return (
    <div
      className="max-w-3xl mx-auto p-6 mt-6 rounded-lg shadow-lg"
      style={{ background: colors.grayLight }}
    >
      <h2
        className="text-2xl font-bold mb-4 text-center"
        style={{ color: colors.primary }}
      >
        Create New Exam
      </h2>

      <p className="text-center" style={{ color: colors.grayDark }}>
        Yahan tum apna new exam create karoge.
      </p>

      {/* Add your exam form fields here */}
    </div>
  );
};

export default CreateExam;
